<template>
  <div>
    <home-head />
      <router-view />
    <foot @showPopup="showPopup" />
    <van-popup v-model="popUpShow">
      <div class="pop_content">
        <van-image
          style="vertical-align: bottom"
          fit="contain"
          width="300"
          height="300"
          :src="qrCodeSrc"
        />
        <span class="tip">请长按识别二维码进入小程序</span>
      </div>
    </van-popup>
  </div>
</template>
<script>
import service from "../api/service";
import homeHead from "./homeHead";
import foot from "./foot";

export default {
  name: "layout",
  components: { homeHead, foot },
  data() {
    return {
      popUpShow: false,
      qrCodeSrc: require("../assets/ojkaQ5VnM0xgtlzjU6S_5HFZ1CrY.jpg"),
    };
  },
  mounted() {},
  methods: {
    showPopup() {
      this.popUpShow = true;
    },
  },
};
</script>
<style scoped>
.pop_content {
  display: flex;
  flex-direction: column;
}

.pop_content .tip {
  text-align: center;
  font-size: 18px;
  padding: 10px;
}

.van-popup {
  overflow: visible;
}
</style>
